export default "__VITE_ASSET__BfY6Nf0t__"